import gtag, { install, gtm_push } from '../tracker/gtag';
import { DeviceUUID } from 'device-uuid/lib/device-uuid';
import { v4 as uuidv4 } from 'uuid';

let device_uuid = new DeviceUUID().get();
let session_uuid = uuidv4();

let microsite_project_id = $('.whatsapp-form [name="project_id"]').val();
let microsite_superleads_id = $('#nndc-footer__superleads-id').val();
let microsite_project_name = $('.whatsapp-form [name="project_name"]').val();
let microsite_project_status = null;
//let microsite_event_category = 'TWO-Microsite';
let current_url = window.location.href;
let microsite_project_province = null;
let microsite_project_city = null;
let microsite_project_district = null;

let environment_type = 'production';
let base_url_api_crm = '/wp-json/wk/v1/project';

// eslint-disable-next-line no-undef
if (typeof global_params['environment_type'] !== 'undefined') {
  // eslint-disable-next-line no-undef
  environment_type = global_params['environment_type'];
}

let tracker_destination = 'microsite';

// eslint-disable-next-line no-undef
if (typeof global_params['tracker_destination'] !== 'undefined') {
  // eslint-disable-next-line no-undef
  tracker_destination = global_params['tracker_destination'];
}

// eslint-disable-next-line no-undef
let gtm_tracking_id = global_params['r123_gtm_container_id'];
// eslint-disable-next-line no-undef
let microsite_event_name = global_params['ms_gtm_event_name'];

// <!-------------------- get project status
let getJSON = function(url, callback) {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'json';
    xhr.onload = function() {
      let status = xhr.status;
      if (status === 200) {
        callback(null, xhr.response);
      } else {
        callback(status, xhr.response);
      }
    };
    xhr.send();
};

document.addEventListener('DOMContentLoaded', () => {
  if (document.body.classList.contains('page-template-template-microsite-two')) {
    getJSON(base_url_api_crm + '?id=' + microsite_superleads_id,
    function(err, developer) {
      if (err !== null) {
        console.log('Something went wrong: ' + err);
      } else {
        microsite_project_status = developer.data.ext_ls_additional_data.project_status;
        microsite_project_province = developer.data.ext_ls_additional_data.province;
        microsite_project_city = developer.data.ext_ls_additional_data.city;
        microsite_project_district = developer.data.ext_ls_additional_data.district;
        sessionStorage.setItem('TSWA', JSON.stringify(developer.data.ext_ls_additional_data.whatsapp_business_number));
      }
    });
  }
});
// --------------------!> end of get project status

function install_ga_code() {
  let GATrackingId = 'UA-26220079-18';

  // for STAGING environment
  if (current_url.includes('microsites') || current_url.includes('local') || environment_type == 'staging') {
      GATrackingId = 'UA-159993116-1';
  }

  let GASetConfigs = {
      'custom_map': {
          'dimension1': 'project_id',
          'dimension2': 'project_name',
          'dimension3': 'project_status',
          'dimension5': 'province',
          'dimension6': 'city',
          'dimension7': 'district',
          'dimension8': 'user_id',
          'dimension9': 'session_id',
          'dimension10': 'superleads_id',
      },
  };

  setTimeout(function() {
    let GAConfigOptions = {
      'project_id': microsite_project_id,
      'page_path': current_url,
      'project_name': microsite_project_name,
      'project_status': microsite_project_status,
      'province' : microsite_project_province,
      'city' : microsite_project_city,
      'district' : microsite_project_district,
      'user_id' : device_uuid,
      'session_id': session_uuid,
      'superleads_id': microsite_superleads_id,
    };

    install(GATrackingId, GASetConfigs, GAConfigOptions);
  }, 1000);
}

function install_gtm_code() {
  setTimeout(function() {
    install(gtm_tracking_id, null, null);
  }, 1000);
}

if (tracker_destination == 'r123') {
  install_gtm_code();
} else {
  install_ga_code();
}

export const gtag_event = (event_name, label, value) => {
  if (event_name === undefined && value === undefined) {
      return;
  }

  if (value === undefined) {
      value = 0;
  }

  let event_params = {
    'event_category': current_url,
    'event_label': label,
    'value': value,
    'project_id': microsite_project_id,
    'project_name': microsite_project_name,
    'project_status': microsite_project_status,
    'non_interaction': true,
    'province': microsite_project_province,
    'city': microsite_project_city,
    'district': microsite_project_district,
    'user_id' : device_uuid,
    'session_id': session_uuid,
    'superleads_id': microsite_superleads_id,
  };

  let is_cta_leads_btn = (event_name.toLowerCase().includes('whatsapp') || event_name.toLowerCase().includes('chat'));
  let is_cta_leads_type_brochure = (label && (typeof label === 'string' ? label.toLowerCase().includes('brochure') : false));

  if (is_cta_leads_btn != is_cta_leads_type_brochure) {
    event_params['cta_type'] = 'whatsapp';
  }

  if (is_cta_leads_btn && is_cta_leads_type_brochure) {
    event_params['cta_type'] = 'brochure';
  }

  if (tracker_destination == 'r123') {
    event_params['event'] = microsite_event_name;
    event_params['event_name'] = event_name;
    gtm_push(event_params);
  } else {
    gtag('event', event_name, event_params);
  }
}

window.global_gtag_event = gtag_event;
export default gtag_event;



// WEBPACK FOOTER //
// ./scripts/routes/gtag-init.js